export default __webpack_public_path__ + "static/media/agusic.4439ed74.svg";